import { Component, defineComponent } from '@decify/cell-shopify/client';
import './TextField.scss';
export const textFieldName = 'TextField';
export const textFieldTagName = 'cell-component-text-field';
export const textFieldInputEvent = 'input';
export const textFieldChangeEvent = 'change';
export class TextField extends Component {
    elements;
    constructor() {
        super(textFieldName);
        const inputElement = this.querySelector('input, textarea');
        if (!inputElement) {
            throw new Error('Input or textarea element not found');
        }
        if (!(inputElement instanceof HTMLInputElement) &&
            !(inputElement instanceof HTMLTextAreaElement)) {
            throw new Error('Element is not an input or textarea element');
        }
        this.elements = {
            input: inputElement,
        };
        this.handleInputEvent = this.handleInputEvent.bind(this);
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
    }
    componentDidMount() {
        // This event will fire every time the user types in the input element.
        this.elements.input.subscribe('input', this.handleInputEvent);
        // This event will fire every time the user types in the input element AND when the input
        // element gets blurred.
        this.elements.input.subscribe('change', this.handleChangeEvent);
    }
    handleInputEvent() {
        this.publish(textFieldInputEvent, { value: this.elements.input.value, element: this });
    }
    handleChangeEvent() {
        this.publish(textFieldChangeEvent, { value: this.elements.input.value, element: this });
    }
}
defineComponent(textFieldTagName, TextField);
